import { render, staticRenderFns } from "./CapsuleMultiselect.vue?vue&type=template&id=23b3c316&scoped=true"
import script from "./CapsuleMultiselect.vue?vue&type=script&lang=ts"
export * from "./CapsuleMultiselect.vue?vue&type=script&lang=ts"
import style0 from "./CapsuleMultiselect.vue?vue&type=style&index=0&id=23b3c316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b3c316",
  null
  
)

export default component.exports